import { useState } from "react";
import type { FormEvent } from "react";
import { Link } from "react-router-dom";
import { api, errorMessage, isNetworkError, useApiMutation } from "../../api";
import { Button, EmptyState, Field } from "../../components";
import { ROUTES } from "../../shell";
import styles from "./Auth.module.css";
import { useLiensTransition } from "../../motion";

/**
 * Mot de passe oublié. Quoi que réponde le serveur (il répond toujours 202),
 * le même écran : « si un compte existe, un courriel est parti ». Seule une
 * panne réseau montre une erreur.
 */
export function MotDePasseOubliePage() {
  const lien = useLiensTransition();
  const [email, setEmail] = useState("");
  const [envoye, setEnvoye] = useState(false);
  const demande = useApiMutation((e: string) => api.forgotPassword({ email: e }));

  async function soumettre(e: FormEvent) {
    e.preventDefault();
    await demande.run(email.trim());
    setEnvoye(true);
  }

  if (envoye && !isNetworkError(demande.error)) {
    return (
      <EmptyState
        icon="✉️"
        title="Si un compte existe pour cette adresse, un e-mail vient d'être envoyé."
        description="Ouvrez le lien qu'il contient pour choisir un nouveau mot de passe. Il n'est valable qu'une heure."
        action={<Link to={ROUTES.connexion} {...lien(ROUTES.connexion, "cube-arriere")}>Retour à la connexion</Link>}
      />
    );
  }

  return (
    <>
      <div>
        <h1 className={styles.titre}>Mot de passe oublié</h1>
        <p className={styles.intro}>
          Indiquez l'adresse de votre compte. Nous vous enverrons un lien pour en choisir un nouveau.
        </p>
      </div>
      <form className={styles.formulaire} onSubmit={(e) => void soumettre(e)} noValidate>
        {isNetworkError(demande.error) && (
          <p className={styles.alerte} role="alert">
            {errorMessage(demande.error)}
          </p>
        )}
        <Field label="Adresse e-mail" required>
          {(commande) => (
            <input
              {...commande}
              type="email"
              autoComplete="username"
              inputMode="email"
              spellCheck={false}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={demande.pending}
            />
          )}
        </Field>
        <Button type="submit" variant="primary" fullWidth loading={demande.pending} disabled={email.trim() === ""}>
          Envoyer le lien
        </Button>
        <div className={styles.liens}>
          <Link to={ROUTES.connexion} {...lien(ROUTES.connexion, "cube-arriere")}>Retour à la connexion</Link>
        </div>
      </form>
    </>
  );
}
